import { useState, useContext, useEffect, useRef } from "react";
import PriceBadge from "../../Components/Step4/PriceBadge";
import "./step4.css";
import PortalContext from "../PortalContext";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  OverlayView,
} from "@react-google-maps/api";
import { sendGetRequest } from "../../Client";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Info } from "lucide-react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

export default function ServiceBlock(props) {
  const { portal } = useContext(PortalContext);

  const [loaded, setLoaded] = useState(false);

  const mapRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyC8kOFpMIzNKTgoey7z1yoGhXJOqtGYomg",
  });

  const scrollToMap = () => {
    mapRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const [loadingLocations, setLoadingLocations] = useState();

  const [availableLocations, setAvailableLocations] = useState();

  const [locationsContent, setLocationsContent] = useState();

  const [mapInstance, setMapInstance] = useState(null);

  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  const [selectedMarker, setSelectedMarker] = useState(false);

  const [submitting, setSubmitting] = useState(false);

  const locations = async () => {
    setLoadingLocations(true);

    const res = await sendGetRequest(
      `api/v2-label-portal-services-dropoff-points.php?serviceProvider=${
        props.data.serviceProvider
      }&country=${portal?.step2?.country}&postcode=${encodeURIComponent(
        portal?.step2?.postcode
      )}&address1=${portal?.step2?.address1}&town=${
        portal?.step2?.town
      }&county=${portal?.step2?.county}&serviceExternalCode=${
        props.data.serviceExternalCode
      }&serviceID=${props.data.serviceID}`
    );

    setLoadingLocations(false);

    setLocationsContent(res.content);

    setLoaded(true);

    setAvailableLocations(res.locations);
  };

  useEffect(() => {
    locations();
  }, []);

  useEffect(() => {
    if (mapInstance && availableLocations?.length) {
      const bounds = new window.google.maps.LatLngBounds();
      availableLocations.forEach((location) => {
        bounds.extend({ lat: Number(location.lat), lng: Number(location.lng) });
      });

      if (!bounds.isEmpty()) {
        mapInstance.fitBounds(bounds);
      }
    }
  }, [mapInstance, availableLocations]);

  const Spinner = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ marginLeft: 8, flexShrink: 0 }}
    >
      <defs>
        <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
          <stop stopColor="#fff" stopOpacity="0" offset="0%" />
          <stop stopColor="#fff" stopOpacity=".631" offset="63.146%" />
          <stop stopColor="#fff" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)">
          <path
            d="M36 18c0-9.94-8.06-18-18-18"
            stroke="currentColor"
            strokeWidth="2"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="0.8s"
              repeatCount="indefinite"
            />
          </path>
          <circle fill="currentColor" cx="36" cy="18" r="1">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="0.8s"
              repeatCount="indefinite"
            />
          </circle>
        </g>
      </g>
    </svg>
  );

  return (
    <>
      <a key={1234}>
        <div
          className="box p-3"
          style={{
            borderRadius: "10px",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ width: "50px", height: "50px", flexShrink: 0 }}>
              {!loaded ? (
                <Skeleton
                  circle
                  height="100%"
                  width="100%"
                  containerClassName="avatar-skeleton"
                />
              ) : (
                <img
                  src={props.data.logoURL}
                  alt="Logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>

            <div
              style={{
                flexBasis: "60%",
                textAlign: "left",
                fontWeight: "600",
                fontSize: "16px",
                color: portal.data.settings.colours.primary,
                paddingHorizontal: "10px",
                marginLeft: "10px",
              }}
            >
              {!loaded ? (
                <Skeleton width={70} />
              ) : (
                props.data.serviceNameCustomer
              )}
            </div>

            <div
              style={{ flexBasis: "15%", flexShrink: 0, textAlign: "right" }}
            >
              {!loaded ? (
                <Skeleton width={70} />
              ) : (
                <PriceBadge text={props.data.formattedSellPrice} serviceProvider={props.data.serviceProvider} />
              )}
            </div>
          </div>

          {!loaded ? (
            <Skeleton width={"100%"} height={"50px"} />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "15px",
                maxWidth: "100%",
              }}
            >
              <a
                style={{
                  flexGrow: 1,
                  backgroundColor: portal.data.settings.colours.primary,
                  color: "white",
                  borderRadius: "5px",
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minWidth: "180px",
                  height: "40px",
                  cursor: "pointer",
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (submitting) return;
                  setSubmitting(true);

                  try {
                    await new Promise((r) => setTimeout(r, 600));
                    await props.onSubmit?.(props.data);
                  } finally {
                    setSubmitting(false);
                  }
                }}
                aria-busy={submitting ? "true" : "false"}
                aria-disabled={submitting ? "true" : "false"}
              >
                {!submitting ? (
                  <>
                    <span>Get {props.data.serviceNameCustomer} label</span>
                    <span style={{ marginLeft: "10px", fontSize: "16px" }}>
                      &rsaquo;
                    </span>
                  </>
                ) : (
                  <>
                    <span>Processing…</span>
                    <Spinner />
                  </>
                )}
              </a>

              <Info
                size={24}
                color={portal.data.settings.colours.primary}
                className="has-tooltip"
                data-max-weight={props.data.maxWeight}
                data-max-dimensions={props.data.maxDimensions}
                data-max-claim={props.data.maximumCompensation}
                style={{
                  marginLeft: 10,
                  alignSelf: "center",
                  cursor: "pointer",
                }}
              />

              <Tooltip
                anchorSelect=".has-tooltip"
                place="top"
                className="my-tooltip"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
                render={({ activeAnchor }) => {
                  if (!activeAnchor) return null;
                  const w = activeAnchor.getAttribute("data-max-weight");
                  const d = activeAnchor.getAttribute("data-max-dimensions");
                  const c = activeAnchor.getAttribute("data-max-claim");
                  return (
                    <div style={{ lineHeight: 1.25 }}>
                      <div>
                        <strong>Max weight:</strong> {w}
                      </div>
                      <div>
                        <strong>Max dimensions:</strong> {d}
                      </div>
                      {c.length > 0 && (
                        <div>
                          <strong>Max claim:</strong> £{c}
                        </div>
                      )}
                    </div>
                  );
                }}
              />
            </div>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                flex: 1,
                textAlign: "left",
                fontWeight: 400,
                fontSize: "14px",
                color: "#333333",
                marginTop: "20px",
              }}
            >
              {!loaded ? (
                <Skeleton width={"100%"} height={"80px"} />
              ) : (
                props.data.serviceDetails
              )}
            </div>
          </div>

          {!loaded && (
            <Skeleton
              width={"100%"}
              height={"120px"}
              style={{ marginTop: "15px" }}
            />
          )}

          {isLoaded && availableLocations?.length > 0 ? (
            <>
              {portal?.data?.settings?.googlemaps === true &&
              localStorage.getItem("disableGoogleMaps") !== "true" ? (
                <div
                  className="map-container"
                  ref={mapRef}
                  style={{ marginTop: "15px" }}
                >
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    options={{
                      mapTypeControl: false,
                      fullscreenControl: false,
                      streetViewControl: false,
                      zoomControl: true,
                      cameraControl: false,
                    }}
                    onLoad={(map) => {
                      setMapInstance(map);
                    }}
                  >
                    <>
                      {selectedMarker && (
                        <OverlayView
                          position={{
                            lat: selectedMarker.lat + 0.008,
                            lng: selectedMarker.lng - 0.016,
                          }}
                          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        >
                          <div
                            style={{
                              background: "white",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              padding: "10px",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                              maxWidth: "200px",
                              position: "relative",
                              width: "200px",
                            }}
                          >
                            <button
                              style={{
                                position: "absolute",
                                top: "4px",
                                right: "4px",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                width: "20px",
                                height: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() => setSelectedMarker(null)}
                              aria-label="Close"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25px"
                                height="25px"
                                viewBox="0 0 24 24"
                                fill="black"
                              >
                                <path
                                  d="M18 6L6 18M6 6l12 12"
                                  stroke="black"
                                  strokeWidth="2"
                                />
                              </svg>
                            </button>
                            <strong>{selectedMarker.title}</strong>
                          </div>
                        </OverlayView>
                      )}

                      {availableLocations?.map((location, key) => (
                        <Marker
                          onClick={() => {
                            setSelectedMarker(location);
                            if (mapInstance) {
                              mapInstance.setZoom(13);
                              mapInstance.panTo({
                                lat: Number(location.lat),
                                lng: Number(location.lng),
                              });
                            }
                          }}
                          key={key}
                          position={{
                            lat: Number(location.lat),
                            lng: Number(location.lng),
                          }}
                        />
                      ))}
                    </>
                  </GoogleMap>
                </div>
              ) : null}

              {availableLocations.map((location, key) => (
                <div
                  key={key}
                  className="cursor-pointer"
                  onClick={() => {
                    setSelectedMarker(location);
                    if (mapInstance) {
                      mapInstance.setZoom(13);
                      mapInstance.panTo({
                        lat: Number(location.lat),
                        lng: Number(location.lng),
                      });
                    }
                    scrollToMap();
                  }}
                >
                  <div
                    className="service-title mt-4"
                    style={{
                      color: `${portal.data.settings.colours.primary}`,
                    }}
                  >
                    {location.title}
                  </div>
                  <div className="service-body">{location.address}</div>
                  <div className="service-body">{location.price}</div>
                </div>
              ))}
            </>
          ) : (
            <div
              style={{
                textAlign: "left",
                fontWeight: 400,
                fontSize: "14px",
                color: portal.data.settings.colours.primary,
              }}
              className="mt-4"
              dangerouslySetInnerHTML={{ __html: locationsContent }}
            />
          )}
        </div>
      </a>
    </>
  );
}
